import React from 'react';
import { Coffee, GraduationCap, Truck, Cake, Heart, CalendarCheck } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Coffee,
  GraduationCap,
  Truck,
  Cake,
  Heart,
  CalendarCheck
};

export const ServicesSection = () => {
  return (
    <section id="services" className="py-16 sm:py-24 lg:py-32 bg-[#1e1919]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="inline-block text-[#fad24b] font-medium text-xs sm:text-sm tracking-wider uppercase mb-3 sm:mb-4">
            Was wir bieten
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
            Unsere Services
          </h2>
          <p className="text-[#bbb5ae] text-base sm:text-lg max-w-2xl mx-auto px-2">
            Von Frühstück bis Catering – wir begleiten Sie durch den ganzen Tag 
            mit frischen Backwaren und zuverlässigem Service.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative bg-[#2a2525] rounded-xl sm:rounded-2xl p-5 sm:p-8 transition-all duration-500 hover:bg-[#352f2f] hover:-translate-y-2 hover:shadow-2xl overflow-hidden"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Decorative Gradient */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-[#61525a]/10 rounded-full blur-3xl transition-all duration-500 group-hover:bg-[#fad24b]/10" />
                
                {/* Icon */}
                <div className="relative w-12 sm:w-14 h-12 sm:h-14 bg-[#61525a] rounded-lg sm:rounded-xl flex items-center justify-center mb-4 sm:mb-6 transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">
                  <IconComponent className="w-6 sm:w-7 h-6 sm:h-7 text-white" />
                </div>

                {/* Content */}
                <h3 className="relative text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3 transition-colors duration-300 group-hover:text-[#fad24b]">
                  {service.title}
                </h3>
                <p className="relative text-[#bbb5ae] text-sm sm:text-base leading-relaxed">
                  {service.description}
                </p>

                {/* Hover Line */}
                <div className="absolute bottom-0 left-0 w-0 h-1 bg-[#fad24b] transition-all duration-500 group-hover:w-full" />
              </div>
            );
          })}
        </div>

        {/* Special Note */}
        <div className="mt-10 sm:mt-16 text-center">
          <div className="inline-flex items-center gap-2 sm:gap-3 bg-[#2a2525] rounded-full px-4 sm:px-6 py-2.5 sm:py-3">
            <Heart className="w-4 sm:w-5 h-4 sm:h-5 text-[#ff8c19]" />
            <span className="text-white text-sm sm:text-base">
              Spezielle Backwaren für <span className="text-[#fad24b] font-medium">Diabetiker</span> erhältlich
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
